import { SpinnerIcon } from "./icons";
import { cn } from "@/shared/lib/cn";
import { messages } from "@/shared/i18n";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

/**
 * Loading Spinner komponens betöltési állapot jelzésére.
 *
 * Használat:
 * ```tsx
 * <LoadingSpinner />
 * <LoadingSpinner size="lg" />
 * <Suspense fallback={<LoadingSpinner />}>
 *   <LazyComponent />
 * </Suspense>
 * ```
 */
export function LoadingSpinner({ size = "md", className }: LoadingSpinnerProps) {
  return (
    <div className="flex min-h-50 items-center justify-center">
      <SpinnerIcon
        aria-label={messages.components.accessibility.loading}
        className={cn(
          "text-brand-primary animate-spin",
          size === "sm" && "h-6 w-6",
          size === "md" && "h-10 w-10",
          size === "lg" && "h-16 w-16",
          className
        )}
        role="status"
      />
    </div>
  );
}
